import React, { useEffect, useState } from 'react';
import setMonth from 'date-fns/esm/setMonth';
import setYear from 'date-fns/esm/setYear';
import getDaysInMonth from 'date-fns/esm/getDaysInMonth';
import getYear from 'date-fns/esm/getYear';
import { useTranslation } from 'react-i18next';

import { getMonthOptions } from 'utils/options';
import Select from '../Select';

import { DateSelectProps } from './types';

import css from './DataSelect.module.scss';

const dayOptions = Array.from({ length: 31 }, (_, i) => ({
    label: i + 1,
    value: i + 1,
}));

const yearOptions = (() => {
    const currentYear = getYear(new Date());

    return Array.from({ length: 111 }, (_, i) => ({
        label: currentYear - i,
        value: currentYear - i,
    }));
})();

const tripsYearOptions = (() => {
    const currentYear = getYear(new Date());

    return Array.from({ length: 111 }, (_, i) => ({
        label: currentYear + i,
        value: currentYear + i,
    }));
})();

const DateSelect: React.FC<DateSelectProps & { error?: boolean }> = ({ value, onChange, error, forTrips }) => {
    const { t } = useTranslation();

    const [selectedDay, setSelectedDay] = useState(0);
    const [selectedMonth, setSelectedMonth] = useState(0);
    const [selectedYear, setSelectedYear] = useState(0);

    const monthOptions = getMonthOptions(t);

    const maxDay = (() => {
        if (selectedMonth) {
            let date = setMonth(new Date(), selectedMonth - 1);
            if (selectedYear) {
                date = setYear(date, selectedYear);
            }
            const daysInMonth = getDaysInMonth(date);

            if (daysInMonth < selectedDay) {
                setSelectedDay(daysInMonth);
            }

            return daysInMonth;
        } else {
            return 31;
        }
    })();

    useEffect(() => {
        if (value && !isNaN(Date.parse(value))) {
            const [year, month, day] = value.split('-');

            setSelectedDay(parseInt(day));
            setSelectedMonth(parseInt(month));
            setSelectedYear(parseInt(year));
        }
    }, [value]);

    useEffect(() => {
        if (selectedDay && selectedMonth && selectedYear) {
            onChange(
                `${selectedYear}-${selectedMonth < 10 ? '0' : ''}${selectedMonth}-${
                    selectedDay < 10 ? '0' : ''
                }${selectedDay}`,
            );
        }
        // onChange in deps array calls infinite rerender
        // eslint-disable-next-line
    }, [selectedDay, selectedMonth, selectedYear]);

    return (
        <div className={css.dataSelect}>
            <Select
                options={dayOptions.slice(0, maxDay)}
                error={error}
                value={dayOptions.find((option) => option.value === selectedDay)}
                placeholder={t('Common.DateTime.Day')}
                onChange={(event) => setSelectedDay(event.value as number)}
            />

            <Select
                options={monthOptions}
                error={error}
                value={monthOptions.find((month) => month.value === selectedMonth)}
                placeholder={t('Onboarding.Signup.FirstStep.Month')}
                onChange={(event) => setSelectedMonth(event.value as number)}
            />

            <Select
                options={forTrips ? tripsYearOptions : yearOptions}
                error={error}
                value={
                    forTrips
                        ? tripsYearOptions.find((year) => year.value === selectedYear)
                        : yearOptions.find((year) => year.value === selectedYear)
                }
                placeholder={t('Common.DateTime.Year')}
                onChange={(event) => setSelectedYear(event.value as number)}
            />
        </div>
    );
};

export default DateSelect;
